import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { reportingOp } from 'store/ducks/Reportings';
import { RootState } from 'store/configureStore';
import { set_isAdditionalDisplayed } from 'store/ducks/Reportings/reportingSlice';
import { DataTypeReportICTServices } from 'store/ducks/Reportings/types';
import { columnsIctServicesDetails } from 'components/Columns/ReportICTServicesColumns';

interface reportICTServicesProps {
  entityName: string;
}

const ReportICTServicesDetails: React.FC<reportICTServicesProps> = ({
  entityName,
}) => {
  const { date, is_additional_displayed } = useSelector(
    (state: RootState) => state.reportings,
  );
  const [data, setData] = useState<DataTypeReportICTServices[]>([]);
  const dispatch = useDispatch();

  const fetchData = async () => {
    dispatch(set_isAdditionalDisplayed(false));
    const params = {
      entity_name: entityName,
      date,
    };
    try {
      const fetchedData = await reportingOp.fetchReportICTServices(params);
      if (fetchedData && Array.isArray(fetchedData.filtered_data)) {
        const date = fetchedData.date;
        const entityName = fetchedData.entity_name;

        const formattedData = fetchedData.filtered_data.map(
          (dataItem: any, index: number) => ({
            key: index,
            date,
            entity_name: entityName,
            alternatives_exit: dataItem.alternatives_exit,
            auswahl_services_discount: dataItem.auswahl_services_discount,
            contractual_arrangement: dataItem.contractual_arrangement,
            country: dataItem.country,
            criticality_assessment: dataItem.criticality_assessment,
            end_date: dataItem.end_date,
            exit_plan_exists: dataItem.exit_plan_exists,
            function_name: dataItem.function_name,
            ict_service_description: dataItem.ict_service_description,
            ict_service_level: dataItem.ict_service_level,
            ict_service_type: dataItem.ict_service_type,
            ict_services_criticality: dataItem.ict_services_criticality,
            impact_of_discontinuing_function:
              dataItem.impact_of_discontinuing_function,
            impact_of_discontinuing_ict_services:
              dataItem.impact_of_discontinuing_ict_services,
            level_of_reliance: dataItem.level_of_reliance,
            level_of_supporting_ict_service:
              dataItem.level_of_supporting_ict_service,
            local_regulator_criticality: dataItem.local_regulator_criticality,
            notice_period: dataItem.notice_period,
            possibility_of_reintegration: dataItem.possibility_of_reintegration,
            rank: dataItem.rank,
            recipient_identification_code:
              dataItem.recipient_identification_code,
            recipient_identification_type:
              dataItem.recipient_identification_type,
            start_date: dataItem.start_date,
            storage_of_data: dataItem.storage_of_data,
            substitutability_of_ict_provider:
              dataItem.substitutability_of_ict_provider,
            third_party_service_provider_name:
              dataItem.third_party_service_provider_name,
            tpp_code_type: dataItem.tpp_code_type,
          }),
        );

        setData(formattedData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.log('Error fetching branches:', error);
      setData([]);
    }
  };

  useEffect(() => {
    if (entityName) {
      fetchData();
    }
  }, [is_additional_displayed, entityName]);

  return (
    <>
      <Table
        columns={columnsIctServicesDetails}
        dataSource={data}
        scroll={{ x: 1000, y: 430 }}
      />
    </>
  );
};

export default ReportICTServicesDetails;
